import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error("Caught by ErrorBoundary:", error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#050505", color: "#F5F5F5", padding: 24, textAlign: "center" }}>
          <div>
            <p style={{ fontFamily: "monospace", textTransform: "uppercase", letterSpacing: 3, color: "#EE1C25", fontSize: 12 }}>Freight IQ</p>
            <h1 style={{ fontSize: 28, marginTop: 12 }}>Something interrupted the page.</h1>
            <button onClick={() => window.location.reload()} style={{ marginTop: 20, background: "#EE1C25", color: "#fff", border: "none", padding: "12px 22px", fontFamily: "monospace", textTransform: "uppercase", letterSpacing: 2, cursor: "pointer" }}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
